import { useMemo } from 'react';

import { Stepper } from '@/shared';

export function AuthStepper({
	count = 2,
	active,
}: {
	count?: number;
	active: number;
}) {
	const steps = useMemo(() => {
		return new Array(count).fill({ name: '' }).map((item, key) => {
			return {
				...item,
				active: key <= active,
			};
		});
	}, [count, active]);

	return <Stepper list={steps} />;
}
